<div>
  <div class="uw-modal-header">
    <div class="heading-container">
      <span class="heading2" [innerHtml]="title ? (title | safeHtml): 'my_campaign.title' | translate"></span>
    </div>
    <div>
      <button [title]="'common.close' | translate" attr.aria-label="{{'aria.close_donation_opt_out_modal' | translate}}" (click)="onCancel()" mat-icon-button>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="uw-modal-content scroll-div">
    
    <uw-my-campaign [sideImgSrc]="sideImgSrc" [sideImageAlt]="sideImageAlt"></uw-my-campaign>
    
  </div>
<div class="un-modal-footer align-right">
  <button [title]="'button.cancel' | translate" mat-button (click)="onCancel()">
    {{ "button.cancel" | translate }}
  </button>  
</div>

</div>
